import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
  Divider,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee } from '../../../network/employee';
import {
  addSalaryStructureHr,
  getSalaryStructureHrDetails,
  updateSalaryStructureHr,
} from '../../../network/salaryStructureHr';
import EarningsList from './EarningsList';
import DeductionsList from './DeductionsList';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBills } from 'react-icons/fa6';
const AddSalaryStructureHr = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dataSource, setDataSource] = useState([
    {
      amount: 0,
      depends_on_payment_days: 0,
      do_not_include_in_total: 0,
      amount_based_on_formula: 0,
    },
  ]);
  const [dataSourceDeduction, setDataSourceDeduction] = useState([
    {
      amount: 0,
      depends_on_payment_days: 0,
      do_not_include_in_total: 0,
      amount_based_on_formula: 1,
    },
  ]);
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddEmployeeAdvance } = useMutation({
    mutationKey: ['addEmployeeAdvance'],
    mutationFn: (body) =>
      edit ? updateSalaryStructureHr(body, id) : addSalaryStructureHr(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getSalaryStructureHr] });
      form.resetFields();
      navigate('/salary-structure-hr');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: salaryStructureHrDetails = {}, isLoading } = useQuery({
    queryKey: [queryKeys.getSalaryStructureHr, id],
    queryFn: () => getSalaryStructureHrDetails(id),
    enabled: !!edit,
  });
  // const { data: employee } = useQuery({
  //   queryKey: [queryKeys.getEmployee],
  //   queryFn: () => getEmployee(),
  // });
  const { data: modeOfPayment } = useQuery({
    queryKey: [queryKeys.getSearchSalaryStructure],
    queryFn: () => getSearchApi('Mode of Payment'),
    keepPreviousData: true,
  });
  const { data: payrollPayableAccount } = useQuery({
    queryKey: [queryKeys.getSearchpayrollPayableAccount],
    queryFn: () => getSearchApi('Account'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    // const totalPercentage = dataSource?.reduce(
    //   (total, item) => total + item?.percentage,
    // ) || 0;
    // if (totalPercentage !== 100) {
    //   message.error('Total percentage should be 100%');
    //   return false;
    // }
    setLoadingAdd(true);
    onAddEmployeeAdvance({
      ...values,
      company: companyName,
      currency: 'SAR',
      payroll_frequency: 'Monthly',
      earnings: dataSource,
      deductions: dataSourceDeduction,
      is_default: values?.is_default ? 'Yes' : 'No',
      is_active: values?.is_active ? 'Yes' : 'No',
    });
  };
  useEffect(() => {
    if (edit && salaryStructureHrDetails) {
      setDataSourceDeduction(
        salaryStructureHrDetails?.data?.deductions?.length
          ? salaryStructureHrDetails?.data?.deductions
          : [{}]
      );
      setDataSource(
        salaryStructureHrDetails?.data?.earnings?.length
          ? salaryStructureHrDetails?.data?.earnings
          : [{}]
      );
      form.setFieldsValue({
        ...salaryStructureHrDetails?.data,
      });
    }
  }, [edit, salaryStructureHrDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.UpdateSalaryStructure : t.AddSalaryStructure}
        path="/salary-structure-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.SalaryStructure}
        subTitle={edit ? t.UpdateSalaryStructure : t.AddSalaryStructure}
        icon={<FaMoneyBills />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-salary-structure"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="name"
                    label={t.Name}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.Name} />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="mode_of_payment"
                    label={t.ModeofPayment}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.ModeofPayment}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={modeOfPayment?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payment_account"
                    label={t.paymentAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.paymentAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={payrollPayableAccount?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  <Form.Item
                    name="is_active"
                    label={t.isActive}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  <Form.Item
                    name="is_default"
                    label={t.isDefault}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.Earnings}</Divider>
                <Col span={24}>
                  <EarningsList
                    t={t}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                  />
                </Col>
                <Divider orientation="left">{t.deductions}</Divider>
                <Col span={24}>
                  <DeductionsList
                    t={t}
                    setDataSource={setDataSourceDeduction}
                    dataSource={dataSourceDeduction}
                  />
                </Col>
                <Divider />
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_earning"
                    label={t.totalEarning}
                    hidden={!edit}
                  >
                    <Input
                      placeholder={t.totalEarning}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_deduction"
                    label={t.totalDeduction}
                    hidden={!edit}
                  >
                    <Input
                      placeholder={t.totalDeduction}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddSalaryStructureHr;
